import { type ObjectMode } from '@databases/types';
import {
  type Database,
  DatabaseFieldType,
  type DatabaseValue
} from '@databases/types/database';
import { createField, getExistingDatabase } from '@databases/utils/database/utils';

import { databasesToContentId } from './constants';

export const databaseWithTagField = (): Database<ObjectMode.EXISTING> => {
  const database = getExistingDatabase({
    contentId: databasesToContentId['databaseWithTagField'],
    databaseName: 'Database with tag field',
    entryCount: 1
  });
  const tagField = createField(DatabaseFieldType.SELECT, {
    id: 'tag-field',
    name: 'Priority'
  });
  const mediumOption = {
    color: 'yellowLight' as const,
    id: 'medium',
    label: 'Medium'
  };
  const entryId = database.entries[0];
  const mediumValue: DatabaseValue<DatabaseFieldType.SELECT, object> = {
    type: DatabaseFieldType.SELECT,
    value: [mediumOption.id]
  };

  return {
    ...database,
    fields: [tagField.id],
    fieldsById: {
      [tagField.id]: {
        ...tagField,
        settings: {
          ...tagField.settings,
          multi: false,
          selectOptions: [mediumOption]
        }
      }
    },
    entriesById: {
      [entryId]: {
        ...database.entriesById[entryId],
        values: {
          [tagField.id]: mediumValue
        }
      }
    }
  };
};
